import { render, staticRenderFns } from "./SingleDriverView.vue?vue&type=template&id=6d16e888&"
import script from "./SingleDriverView.vue?vue&type=script&lang=js&"
export * from "./SingleDriverView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports